/*
 * @Description: 更换服务
 * @Author: webJ
 */

import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import servicesProject from './components/servicesProject.vue'
import infiniteLoadData from '@/components/infiniteLoadData/infiniteLoadData.vue'
import { wxShare } from '@/utils/wxsdk'
import _ from 'lodash'

import {
    getAdviceServicesList
} from '@/models/advice.js'

export default {
    name: viewName.selectService,
    components: {
        servicesProject,
        infiniteLoadData
    },
    data () {
        return {
            clientHeight: 0, // 列表高度
            baseItemCode: '',
            sstore_id: '',
            maintain_cate_id: '',
            list: [],
            pagesize: 30,
            page: 1,
            isload: true,
            formRouteName: '' // 来源地址
        }
    },
    computed: {
        ...mapState({
            adviceList: ({ advice }) => advice.list, // 保养项目列表
            selectData: ({ advice }) => advice.selectData.servicesList, // 已选数据
            isWeixin: ({ appInfo }) => appInfo.isWeixin // 是否是微信环境
        }),
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => { // 参数vm就是当前组件的实例。
            vm.formRouteName = from.name
        })
    },
    created () {
    },
    activated () {
        this.$emit('setHeader', {
            title: '选择服务',
            showHeader: true,
            showLeft: true,
        })
        this.setAppClass({
            isAppend: false,
            className: 'bgWhiteColor'
        })

        /* 详情修改同步到服务列表 */
        if (this.formRouteName === 'serviceDetail') {
            const now_service = JSON.parse(sessionStorage.getItem('now_service'))
            console.log('now_service', now_service)
            if (now_service) {
                this.list.forEach((item, index) => {
                    if (item.service_id === now_service.service_id) {
                        item.is_selectd = now_service.is_selectd
                    }
                    this.list[index] = item
                })
            }
        }
    },
    mounted () {
        /* 获取地址参数 */
        const { sstore_id, maintain_cate_id, baseItemCode } = this.$route.query
        this.baseItemCode = baseItemCode
        this.sstore_id = sstore_id
        this.maintain_cate_id = maintain_cate_id
        console.log('service mounted')

        /* 微信分享 */
        this.configWxShare()
    },
    methods: {
        ...mapActions([
            'setAppClass',
            'updateAdviceList'
        ]),
        /**
         * 无限滚动 回调，页面进入默认触发
         */
        infinite: _.throttle(function () {
            console.log('调用1次')
            this.getData()
        }, 1000),
        /**
         * 配置微信分享
         */
        configWxShare () {
            if (this.isWeixin) {
                const ADVICE_HREF = sessionStorage.getItem('ADVICE_HREF')
                wxShare({
                    link: ADVICE_HREF,
                    title: '为您推荐了一份爱车保养方案',
                    imgUrl: 'https://image.carisok.com/images/mall.png',
                    desc: '海量优质车品，智能匹配车型，车辆保养更轻松'
                })
            }
        },
        /*
         * 跳转服务详情
         */
        toServiceDetail (obj) {
            const nowItem = this.list.find((item) => {
                return item.service_id === obj.service_id
            })
            /* 跳转服务详情 */
            this.$router.push({
                path: '/serviceDetail',
                query: {
                    ...obj,
                    source: 'selectService',
                    noOnlyBuy: false,
                    is_selected: nowItem.is_selected
                }
            })
        },
        /**
         * 上拉加载数据，在这里进行操作
         */
        scrollToEnd (scroll) {
            this.isload && this.getData()
        },
        /**
         * 获取数据
         */
        async getData () {
            this.isload = true
            const services_ids = []
            /* 已选的服务id */
            console.log(this.selectData)
            this.selectData.forEach((item) => {
                console.log(item.baseItemCode, this.baseItemCode)
                if (item.baseItemCode === this.baseItemCode) {
                    services_ids.push(item.service_id)
                }
            })
            console.log('services_ids', services_ids)
            const params = {
                /* 已选的服务id */
                selected_id: services_ids.join(','),
                /* 保养分类id */
                maintain_cate_id: this.maintain_cate_id,
                /* 门店id */
                sstore_id: this.sstore_id,
                pagesize: this.pagesize,
                page: this.page
            }
            const res = await getAdviceServicesList(params)
            /* 返回数据需要显示 是否 勾选复选框 ，前端控制 */
            setTimeout(() => {
                const btnBoxHeight = document.querySelector('.btnBox').clientHeight
                this.clientHeight = btnBoxHeight
            }, 300)
            const newArr = res.services.map((item) => {
                if (services_ids.includes(item['service_id'])) {
                    item.is_selectd = 1
                } else {
                    item.is_selectd = 0
                }
                return item
            })
            this.isload = false
            this.list = this.list.concat(newArr)
            if (res.total_page <= this.page) {
                this.page = 1
            } else {
                this.page++
            }
        },
        /**
         * 确认更改服务
         */
        onChangeServices () {
            /* 筛选出已选中的服务 */
            const filterArr = this.list.filter((item) => {
                return Number(item.is_selectd) === 1
            })
            if (filterArr.length === 0) {
                this.$toast('至少选择一项服务')
            } else if (filterArr.length > 20) {
                this.$toast('最多可选择20项')
            } else {
                /* 更新store的数据 */
                const adviceList = JSON.parse(JSON.stringify(this.adviceList))
                const newList = adviceList.map((item) => {
                    if (item.baseItemCode === this.baseItemCode) {
                        item.services = filterArr.map((childrenItem) => {
                            childrenItem.baseItemCode = this.baseItemCode
                            childrenItem.selected_num = 1
                            return childrenItem
                        })
                    }
                    return item
                })
                this.updateAdviceList(newList)
                /* 返回上一页 */
                this.$router.go(-1)
            }
        },
        /**
         * 子节点 是否选择 更改
         */
        checkboxChildrenChange (obj) {
            this.list.forEach((item, index) => {
                var newItem = item
                if (newItem.service_id === obj.childrenId) {
                    newItem.is_selectd = Number(!newItem.is_selectd)
                }
                this.list[index] = newItem
            })
        },
    },
}
